import { EditOutlined, ExportOutlined } from '@ant-design/icons';
import { useGetOriginalUriQuery } from '@app/services';
import { AppProjectClone, useAppDispatch, useAppProjectAbility } from '@common';
import { MagicBrush } from '@assets';
import { AccessAction } from '@common';
import { AppProject } from '@common';
import { setEditAppName, setEditDrawerOpen } from '@pages/MainDashBoard/store';
import { FloatButton } from 'antd';
import useAppname from './useAppname';

export default function ActionButtons({ appInfo }: Props) {
    const { appName } = useAppname();
    const ability = useAppProjectAbility();
    const dispatch = useAppDispatch();

    function handleEditDrawerOpen(name?: string) {
        if (!name) return;
        dispatch(setEditAppName(name));
        dispatch(setEditDrawerOpen(true));
    }
    const { currentData: originalUri } = useGetOriginalUriQuery(appName, { skip: !appInfo });
    const canEdit = ability?.can?.(AccessAction.UPDATE, new AppProjectClone(appInfo as AppProject) as any) || false;

    if (!appInfo) return null;

    return (
        <>
            <FloatButton.Group
                trigger="hover"
                style={{ right: 24 }}
                icon={<MagicBrush />}
            >
                {originalUri && (
                    <FloatButton
                        icon={<ExportOutlined />}
                        tooltip="If it is taking too loading to load, click here to go to original uri"
                        href={originalUri}
                        target="_blank"
                    />
                )}
                {canEdit && (
                    <FloatButton
                        tooltip="Edit App"
                        icon={<EditOutlined />}
                        onClick={() => handleEditDrawerOpen(appInfo?.name)}
                    />
                )}
            </FloatButton.Group>
        </>
    );
}

interface Props {
    appInfo?: AppProject;
}
